import React from "react";
import styled from "styled-components";
import InputWrapper from "../atoms/InputWrapper";
import InputItemWrapper from "../atoms/InputItemWrapper";
import InputCurrencyAmount from "../atoms/InputCurrencyAmount";
import InputRadio from "../atoms/InputRadio";
import InputLabel from "../atoms/InputLabel";
import { firstError } from "../../Services/Form";
import ErrorLabel from "../atoms/ErrorLabel";
import _ from "lodash";
import InputItem from "../atoms/InputItem";
import { isProject, PROJECT_INVONED, } from "../../Services/appTheme";
const StyledInputWrapper = styled(InputWrapper) `
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
`;
const StyledWrapperCurrencyAmount = styled(InputItemWrapper) `
    width: 30%;

    @media only screen and (max-width: 500px) {
        width: 100%;
        margin-bottom: 30px;
        padding: 0;
    }
`;
const StyledSalaryFrequency = styled.div `
    width: 70%;

    @media only screen and (max-width: 500px) {
        width: 100%;
    }
`;
const StyledInputRadio = styled(InputRadio) `
    @media only screen and (max-width: 500px) {
        margin-bottom: 10px;
    }
`;
const StyledInputCurrencyAmount = styled(InputCurrencyAmount) `
    @media only screen and (max-width: 500px) {
        max-width: 100px;
    }
`;
const NetIncome = ({ loading, amount, period, errors, firstPaymentDate, onChange: handleChange, }) => (React.createElement(React.Fragment, null,
    React.createElement(StyledInputWrapper, null,
        React.createElement(StyledWrapperCurrencyAmount, null,
            React.createElement(StyledInputCurrencyAmount, { min: 0, max: 9999, label: "Netto inkomen", name: "net_income", disabled: loading, onChange: handleChange, value: amount, error: errors.net_income, required: true })),
        React.createElement(StyledSalaryFrequency, null,
            React.createElement(InputLabel, { isMandatory: true }, "Betaalperiode per"),
            React.createElement(StyledInputRadio, { name: "payment_frequency", id: "payment_frequency-week", value: "week", label: "Week", disabled: loading, onChange: handleChange, checked: period === "week", required: true }),
            React.createElement(StyledInputRadio, { name: "payment_frequency", id: "payment_frequency-4-weeks", value: "4_weeks", label: "4 weken", disabled: loading, onChange: handleChange, checked: period === "4_weeks", required: true }),
            React.createElement(StyledInputRadio, { name: "payment_frequency", id: "payment_frequency-month", value: "month", label: "Maand", disabled: loading, onChange: handleChange, checked: period === "month", required: true }),
            !!firstError(errors.payment_frequency) && (React.createElement(ErrorLabel, null, _.capitalize(firstError(errors.payment_frequency)))))),
    isProject(PROJECT_INVONED) &&
        React.createElement(InputWrapper, null,
            React.createElement(InputItem, { type: "date", name: "first_payment_date", label: "Datum eerste afdracht", disabled: loading, onChange: handleChange, value: firstPaymentDate, error: errors.first_payment_date }))));
export default NetIncome;
